module.exports = __webpack_public_path__ + "static/Vanille-ad99544bf0b1fc9e616f0f21862a42fd.png";